import {
  INTERNAL_MESSAGE_ERROR_KEY,
  INTERNAL_MESSAGE_SOURCE,
} from './constants';
import { InternalMessage } from './types';

export const sendMessageToEmbed = (message: InternalMessage): boolean => {
  try {
    const target = window.parent;
    if (!target) throw new Error('window.parent not available');
    target.postMessage(
      { ...message, source: INTERNAL_MESSAGE_SOURCE },
      { targetOrigin: '*' }
    );
    return true;
  } catch (error) {
    console.error(`${INTERNAL_MESSAGE_ERROR_KEY} Failed to send message`, {
      message,
      error,
    });
    return false;
  }
};
